import { memo } from 'react'
import './index.scss'

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-elements">
          <p>Build by Abdul Basit</p>
          <ul className="other-pages">
            <li>About Us</li>
            <li>Contact Us</li>
          </ul>
        </div>
      </div>
    </footer>
  )
}

export default memo(Footer)
